const gatewayShipmentLocale = {
  gatewayShipment: {
    request: "Demande d'envoi de pilote",
    requestHistory: {
      title: "Historique",
      description: "Demandes d'envoi de pilote effectuées",
      nGatewaysSent: "{n} pilote envoyé | {n} pilotes envoyés",
      requestType: "Type de demande",
      comment: "Commentaire",
    },
    noGateways: "Aucun matériel",
    noGatewaysWarning:
      "Aucun matériel n'est installé sur site. Impossible de faire une demande d'envoi de pilote sur un site sans matériel.",
    beforeShipment: "Avant tout envoi de matériel :",
    beforeShipmentList: [
      "Envoyer un pilote seulement si nécessaire (après diagnostic)",
      "Vérifier l'adresse postale, le numéro de téléphone principal et l'adresse mail",
      "Le matériel est envoyé sous 5 jours ouvrés à l'adresse renseignée sur VoltaCall",
      "Dans le colis, l'adhérent trouvera un mode opératoire pour installer son nouveau pilote",
    ],
    form: {
      number: "Cause d'envoi du pilote",
      rooms: "Sélectionnez les appareils concernés par l'envoi de pilote",
      sendCause: "Cause d'envoi du pilote",
      sendCausePlaceholder: "Sélectionnez une cause d'envoi du pilote",
      gatewayModelType: "Type de modèle de pilote :",
      commentsPlaceholder: "Commentaire...",
      sendCauseOptions: {
        noGatewayOnSite: "Pas de pilote sur site",
        gatewayHs: "Pilote HS",
        badNetworkConnection: "Mauvaise connexion réseau",
        largeHouseThickWalls: "Grande maison / murs épais",
        other: "Autre",
      },
      gatewayModelTypeOptions: {
        bouygues: "Bouygues",
        kpn: "KPN",
        noPreference: "Aucune importance",
      },
    },
  },
};

export type GatewayShipmentLocale = typeof gatewayShipmentLocale;
export default gatewayShipmentLocale;
